export function convertToTimezone(date: Date, timezone: string) {
  const options = {
    timeZone: timezone,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  const formatter = new Intl.DateTimeFormat("en-US", options as any);
  return formatter.format(date);
}

// <p>{convertToTimezone(new Date(), TIME_ZONES["Alaska Standard Time"])}</p>
